// Effectiveness levels for incident follow-ups (kept as-is)
export const EFFECTIVENESS_LEVELS = {
  COMPLETELY: {
    label: 'Resolved',
    value: 'resolved',
    color: '#4CAF50',
  },
  SOMEWHAT: {
    label: 'Improved',
    value: 'improved',
    color: '#FF9800',
  },
  NOT_EFFECTIVE: {
    label: 'No Change',
    value: 'no_change',
    color: '#F44336',
  },
};
